import React from "react";
import { useParams } from "react-router-dom";
import FallBackComponent from "../ErrorBoundaryComponents/FallBackComponent";

const withSubcomponentValidation = (validSubcomponents = []) => (WrappedComponent) => {
  return (props) => {
    const { subcomponent } = useParams();
    const isValid = validSubcomponents.includes(subcomponent?.toLowerCase());

    return isValid ? <WrappedComponent {...props} /> : <FallBackComponent />;
  };
};

export default withSubcomponentValidation;
